import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { adminBootSx } from './AdminShell.styles';

/** Pantalla neutra mientras corre el gate. Sin copy que delate la consola. */
export default function AdminBootScreen() {
  return (
    <Box sx={adminBootSx}>
      <CircularProgress size={28} />
    </Box>
  );
}
